import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check, FileText } from 'lucide-react';
export function TemplatesSection() {
  const templates = [{
    id: 1,
    title: 'TEMPLATE 1 — Checklist Diario "Noche Silenciosa"',
    desc: 'Tu guía paso a paso de las 6PM a las 10PM. No empieza cuando te acuestas — empieza 4 horas antes, porque así funciona el cuerpo hormonal.',
    table: [{
      col1: '6PM',
      col2: 'Cena ligera del Menú Tranquila',
      col3: 'Sistema digestivo libre = temperatura corporal ideal'
    }, {
      col1: '8PM',
      col2: 'Té Abuela listo',
      col3: 'Activa receptores GABA antes de que llegue la ansiedad'
    }, {
      col1: '9PM',
      col2: 'Luces bajas, sin redes',
      col3: 'Bloquea la luz azul que destruye tu melatonina'
    }, {
      col1: '9:30PM',
      col2: '3 cosas buenas del día',
      col3: 'Baja el cortisol con gratitud específica'
    }, {
      col1: '9:45PM',
      col2: 'Respiración NM — 4 minutos',
      col3: 'Activa el sistema nervioso parasimpático'
    }, {
      col1: '10PM',
      col2: 'Té + journal si es necesario',
      col3: 'Cierra la mente. Luz off. A dormir.'
    }],
    footer: 'Imprime uno por día. Repite 21 días. Se vuelve hábito automático.'
  }, {
    id: 2,
    title: 'TEMPLATE 2 — Té Abuela: Remedio "Noche Silenciosa"',
    desc: 'Receta ancestral mexicana con respaldo bioquímico.',
    table: [{
      col1: 'Manzanilla',
      col2: 'Activa receptores GABA — apaga la ansiedad',
      col3: '$15 MXN'
    }, {
      col1: 'Canela',
      col2: 'Estabiliza glucosa — previene el despertar 3AM',
      col3: '$10 MXN'
    }, {
      col1: 'Manzana roja',
      col2: 'Fuente de magnesio — mineral que escasea en la menopausia',
      col3: '$15 MXN'
    }, {
      col1: 'Miel orgánica (opcional)',
      col2: 'Suaviza y sacia',
      col3: '$10 MXN'
    }],
    footer: 'Costo total para 7 días: $50 MXN en Oxxo o Walmart. Incluye tracker de 7 días para registrar ansiedad y horas de sueño.'
  }, {
    id: 3,
    title: 'TEMPLATE 3 — Journal Ansiedad 3AM: "Libera y Duerme"',
    desc: 'Para cuando despiertas ansiosa a las 3AM — sin abrir el teléfono. El proceso de 5 minutos que transforma el miedo nocturno en calma:',
    table: [{
      col1: 'Paso 1',
      col2: 'El pensamiento exacto que te despertó',
      col3: 'Lo sacas de la mente y lo anclas en papel'
    }, {
      col1: 'Paso 2',
      col2: 'El hecho real (no el miedo)',
      col3: 'Activa el córtex prefrontal — apaga la amígdala'
    }, {
      col1: 'Paso 3',
      col2: 'Qué controlas AHORA mismo',
      col3: 'Recuperas el poder en el momento presente'
    }, {
      col1: 'Paso 4',
      col2: 'Tu afirmación y visión de mañana',
      col3: 'Cierra el ciclo con esperanza, no con miedo'
    }],
    footer: '"Las 3AM no deciden mi mañana." Incluye espacio para 7 entradas semanales.'
  }, {
    id: 4,
    title: 'TEMPLATE 4 — Rutina Respiración NM "Noche + Mente"',
    desc: '4 ejercicios de 2–4 minutos para ansiedad hormonal menopáusica.',
    table: [{
      col1: '4-7-8 Abuela',
      col2: 'Ansiedad alta',
      col3: '4 min'
    }, {
      col1: 'Escaneo Cuerpo Menopausia',
      col2: 'Tensión física acumulada',
      col3: '2 min'
    }, {
      col1: '"Suficiente" Hormonal',
      col2: 'Miedos de finanzas y salud',
      col3: '3 min'
    }, {
      col1: 'NM Final — REM Profundo',
      col2: 'Inducción al sueño profundo',
      col3: '2 min'
    }],
    footer: 'Secuencias personalizadas según tu noche. Checkbox × 21 días.'
  }, {
    id: 5,
    title: 'TEMPLATE 5 — Tracker Semanal: "Progreso Visible"',
    desc: 'Ve tu victoria semana a semana — escrita, real, tuya. Registra: hora que te acostaste, hora que despertaste, despertares nocturnos, energía AM del 1 al 10, si tomaste el té, si hiciste la respiración.',
    table: [],
    footer: 'Meta: 6+ horas de sueño promedio semanal. El progreso visible crea motivación para continuar.'
  }, {
    id: 6,
    title: 'TEMPLATE 6 — Menú Cena Tranquila: 7 Días Mexicanos Ligeros',
    desc: 'Sin hinchazón. Sin reflujo a las 2AM. Sin bajones de azúcar.',
    table: [{
      col1: 'Día 1',
      col2: 'Ensalada de nopales + huevo + limón',
      col3: 'Magnesio relaja el sistema nervioso'
    }, {
      col1: 'Día 2',
      col2: 'Caldo de pollo + zanahoria + apio',
      col3: 'Triptófano → serotonina → melatonina'
    }, {
      col1: 'Día 3',
      col2: 'Tortilla + aguacate + queso fresco',
      col3: 'Grasas buenas activan receptores GABA'
    }, {
      col1: 'Día 4',
      col2: 'Verduras al vapor + yogur natural',
      col3: 'Probióticos reducen ansiedad intestinal'
    }, {
      col1: 'Día 5',
      col2: 'Sopa de lentejas + espinaca',
      col3: 'Hierro y folato para energía estable'
    }, {
      col1: 'Día 6',
      col2: 'Pescado a la plancha + jitomate',
      col3: 'Omega-3 calma la mente inflamada'
    }, {
      col1: 'Día 7',
      col2: 'Avena nocturna + plátano',
      col3: 'Melatonina natural + triptófano'
    }],
    footer: 'Lista de compras semanal incluida. Costo total: ~$250 MXN.'
  }, {
    id: 7,
    title: 'TEMPLATE 7 — Lista "Qué NO Hacer": 7 Errores Comunes 45+',
    desc: 'Los sabotajes invisibles que bloquean todo lo demás.',
    table: [{
      col1: 'Café post-3PM',
      col2: 'En la menopausia, la cafeína tarda el doble en eliminarse',
      col3: 'Cambia a agua de jamaica o descafeinado'
    }, {
      col1: 'WhatsApp a las 9PM+',
      col2: 'La luz azul bloquea la melatonina por 2–3 horas',
      col3: 'Teléfono boca abajo a las 9PM'
    }, {
      col1: 'Cena pesada o picante',
      col2: 'El reflujo te despierta a las 2AM',
      col3: 'Cena antes de las 7PM, ligero'
    }, {
      col1: 'Alcohol "para dormir"',
      col2: 'Fragmenta el sueño REM — amaneces más cansada',
      col3: 'Sustitúyelo con el Té Abuela'
    }, {
      col1: 'Siesta de +30 minutos',
      col2: 'Roba la presión de sueño nocturna',
      col3: 'Máximo 20 min antes de las 3PM'
    }, {
      col1: 'TV o celular encendido',
      col2: 'Mantiene el cerebro en alerta constante',
      col3: 'Ritual de cierre desde las 9PM'
    }, {
      col1: 'Ignorar ansiedad',
      col2: 'Lo que no se procesa, regresa amplificado',
      col3: 'Usa el Template 3 — 5 minutos'
    }],
    footer: 'Método comprobado: Elimina 1 error por semana. 7 semanas = transformación de vida.'
  }];
  return <section className="py-20 px-4 md:px-8 bg-cream-50 text-navy-900" data-id="element-254">
      <div className="max-w-5xl mx-auto" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-256">
          <span className="text-4xl mb-4 block" data-id="element-257">📦</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-258">
            SECCIÓN 4 — LO QUE RECIBES
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-259">
            "7 Templates Listos — Solo Imprimes y Usas Esta Noche"
          </h3>
          <p className="text-xl text-navy-700 max-w-3xl mx-auto" data-id="element-260">
            Sin teoría. Sin pasos imposibles. Sin ingredientes raros. Todo
            diseñado para mujeres mexicanas 45+ — con ingredientes de Oxxo o
            Walmart, rutinas de 10–15 minutos, listo para usar hoy.
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-261">
          {templates.map(template => <motion.div key={template.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-cream-200" data-id="element-262">
              <div className="bg-navy-800 p-6 text-cream-100 flex items-start gap-4" data-id="element-263">
                <div className="bg-gold-500 text-navy-900 p-2 rounded-lg mt-1" data-id="element-264">
                  <Check className="h-6 w-6" data-id="element-265" />
                </div>
                <div data-id="element-266">
                  <h4 className="text-xl md:text-2xl font-serif font-bold mb-2" data-id="element-267">
                    {template.title}
                  </h4>
                  <p className="text-cream-200" data-id="element-268">{template.desc}</p>
                </div>
              </div>

              {template.table.length > 0 && <div className="p-6 overflow-x-auto" data-id="element-269">
                  <div className="min-w-full md:min-w-0" data-id="element-270">
                    {/* Desktop Table Header - Hidden on Mobile */}
                    <div className="hidden md:grid grid-cols-3 gap-4 pb-4 border-b border-cream-200 font-bold text-navy-900 text-sm uppercase tracking-wider" data-id="element-271">
                      <div data-id="element-272">Elemento / Hora</div>
                      <div data-id="element-273">Función / Acción</div>
                      <div data-id="element-274">Beneficio / Costo</div>
                    </div>

                    {/* Rows */}
                    <div className="space-y-4 md:space-y-0" data-id="element-275">
                      {template.table.map((row, idx) => <div key={idx} className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 py-4 border-b border-cream-100 last:border-0 hover:bg-cream-50 transition-colors rounded-lg md:rounded-none p-4 md:p-0 bg-cream-50/50 md:bg-transparent" data-id="element-276">
                          <div className="font-bold text-navy-900 md:font-normal" data-id="element-277">
                            {row.col1}
                          </div>
                          <div className="text-navy-800" data-id="element-278">{row.col2}</div>
                          <div className="text-navy-600 italic text-sm md:text-base" data-id="element-279">
                            {row.col3}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>}

              <div className="bg-cream-100 p-4 text-center border-t border-cream-200" data-id="element-280">
                <p className="font-bold text-navy-800 text-sm md:text-base" data-id="element-281">
                  {template.footer}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}